<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta charset="utf-8"/>
<link href="styles/custom.css" rel="stylesheet" type="text/css"/>
<title>Fasting for Miracles</title>
<p class="ded"><span epub:type="pagebreak" id="page_vii" title="vii"><i>As I considered the dedication for this manuscript, my first thought was of my three children, Jeremy, Joshua, and Jennifer. Miracles are gifts from God. Answers to prayers. Blessings and breakthroughs. That is what you are to me—miracles.</i></span></p>
<p class="ded1"><i>I have received love, encouragement, and joy from each of you. It is with a heart of gratitude that I thank God for my miracles. You are my gift from above.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4cd2ae80